// 待办
import PendingNav from '../view/PendingItems/PendingNav.vue'
import OccupancyApproval from '../view/PendingItems/OccupancyApproval/OccupancyApproval'
import ContractApproval from '../view/PendingItems/ContractApproval/ContractApproval.vue'
import ElectricityApproval from '../view/PendingItems/ElectricityApproval/ElectricityApproval.vue'
import WaterApproval from '../view/PendingItems/WaterApproval/WaterApproval.vue'
import SteamApproval from '../view/PendingItems/SteamApproval/SteamApproval.vue'
import GasApproval from '../view/PendingItems/GasApproval/GasApproval.vue'
import ReviseApproval from '../view/PendingItems/ReviseApproval/ReviseApproval.vue'
import SuggestionApproval from '../view/PendingItems/SuggestionApproval/SuggestionApproval.vue'
import AttendanceApproval from '../view/PendingItems/AttendanceApproval/AttendanceApproval.vue'
import ParkingApplyApproval from '../view/PendingItems/ParkingApplyApproval/ParkingApplyApproval'
import ParkingBackApproval from '../view/PendingItems/ParkingBackApproval/ParkingBackApproval'
import ParkingBackDetail from '../view/PendingItems/ParkingBackDetail/ParkingBackDetail'
import ParkingApplyDetail from '../view/PendingItems/ParkingApplyDetail/ParkingApplyDetail'
import PoliticalCommunicationApproval from '../view/PendingItems/PoliticalCommunicationApproval/PoliticalCommunicationApproval'
import PoliticalCommunicationApprovalDetail from '../view/PendingItems/PoliticalCommunicationApproval/PoliticalCommunicationApprovalDetail'
import FreeCodeApproval from '../view/PendingItems/FreeCodeApproval/FreeCodeApproval'
import RepairApproval from '../view/PendingItems/RepairApproval/RepairApproval'

export default [
  // 待办
  {
    path: '/occupancy_approval',
    name: 'occupancy-approval',
    components: {
      default: PendingNav,
      a: OccupancyApproval
    }
  }, {
    path: '/contract_approval',
    name: 'contract-approval',
    components: {
      default: PendingNav,
      a: ContractApproval
    }
  },
  {
    path: '/electricity_approval',
    name: 'electricity-approval',
    components: {
      default: PendingNav,
      a: ElectricityApproval
    }
  },
  {
    path: '/water_approval',
    name: 'water-approval',
    components: {
      default: PendingNav,
      a: WaterApproval
    }
  }, {
    path: '/steam_approval',
    name: 'steam-approval',
    components: {
      default: PendingNav,
      a: SteamApproval
    }
  }, {
    path: '/gas_approval',
    name: 'gas-approval',
    components: {
      default: PendingNav,
      a: GasApproval
    }
  }, {
    path: '/revise_approval',
    name: 'revise-approval',
    components: {
      default: PendingNav,
      a: ReviseApproval
    }
  }, {
    path: '/suggestion_approval',
    name: 'suggestion-approval',
    components: {
      default: PendingNav,
      a: SuggestionApproval
    }
  }, {
    path: '/attendance_approval',
    name: 'attendance-approval',
    components: {
      default: PendingNav,
      a: AttendanceApproval
    }
  }, {
    path: '/free_code_approval',
    name: 'free-code-approval',
    components: {
      default: PendingNav,
      a: FreeCodeApproval
    }
  }, {
    path: '/parking_apply_approval',
    name: 'parking-apply-approval',
    components: {
      default: PendingNav,
      a: ParkingApplyApproval
    }
  }, {
    path: '/parking_back_approval',
    name: 'parking-back-approval',
    components: {
      default: PendingNav,
      a: ParkingBackApproval
    }
  }, {
    path: '/parking_back_detail/:id',
    name: 'parking-back-detail',
    components: {
      default: PendingNav,
      a: ParkingBackDetail
    }
  }, {
    path: '/parking_apply_detail/:id',
    name: 'parking-apply-detail',
    components: {
      default: PendingNav,
      a: ParkingApplyDetail
    }
  }, {
    path: '/political_communication_approval',
    name: 'political-communication-approval',
    components: {
      default: PendingNav,
      a: PoliticalCommunicationApproval
    }
  }, {
    path: '/political_communication_approval_detail',
    name: 'political-communication-approval-detail',
    components: {
      default: PendingNav,
      a: PoliticalCommunicationApprovalDetail
    }
  }, 
  // {
  //   path: '/repair_approval',
  //   name: 'repair-approval',
  //   components: {
  //     default: PendingNav,
  //     a: RepairApproval
  //   }
  // }
]



// WEBPACK FOOTER //
// ./src/router/PendingItems.js